import { useEffect, useState } from 'react'
import api from '../../services/api'
import { Nav, Container, Card, Table } from 'react-bootstrap'
import TableContainer from '@material-ui/core/TableContainer'
import Paper from '@material-ui/core/Paper'

import './styles.css'

import NavBar from '../../components/NavBar/NavBar.js'
import SideBar from '../../components/SideBar'
import Corpobackup from '../../components/CorpoBackups'
import Alert from '../../components/Alerts'

function ReportSemanal() {
  const idEmpresa = localStorage.getItem('idEmpresa')
  const name = localStorage.getItem('name_empresa')
  const alertas = localStorage.getItem('alertas')
  const [body, setBody] = useState([])

  useEffect(() => {
    ;(async () => {
      api.get('/backups?idEmpresa=' + idEmpresa).then((response) => {
        const respost = response.data
        setBody(respost)
      })
    })()
  }, [])
  const data = new Date().toLocaleDateString()
  const splidData = data.split('/')
  let dia = splidData[0]
  let mes = splidData[1]
  let ano = splidData[2]
  return (
    <div>
      <NavBar />
      <div className="MainDashboardMain">
        <div className="main">
          <TableContainer component={Paper}>
            <Container>
              <br />
              <Card.Header>Mes: {mes}</Card.Header>
              <br />
              <Card>
                <Card.Header>{name}</Card.Header>
                <Card.Body>
                  <div>
                    <Card.Text>
                      <strong>
                        {' '}
                        {dia}/{mes}
                      </strong>
                      <Table
                        responsive
                        striped
                        bordered
                        hover
                        variant="light"
                        size="sm"
                      >
                        <thead>
                          <tr>
                            <td>Empresa</td>
                            <td>HOST</td>
                            <td>Backup</td>
                            <td>Files</td>
                            <td>Size</td>
                            <td>Disc Space</td>
                            <td>Status</td>
                            <td>Data</td>
                          </tr>
                        </thead>
                        {body
                          .sort((a, b) => a.backup.localeCompare(b.backup))
                          .map((body) => {
                            const getDate01 = new Date(
                              body.started_at
                            ).toLocaleDateString()
                            let handleDia
                            let handleMes = ''
                            if (dia <= 1) {
                              handleMes = '0'
                              dia = '0'
                            } else if (dia <= 10) {
                              handleDia = `0`
                            } else if (dia >= 10) {
                              handleDia = ''
                            }
                            const montaData = `${dia}/${handleMes}${mes}/${ano}`
                            if (getDate01 != montaData) return ' '
                            return <Corpobackup key={body.id} data={body} />
                          })}
                        <br />
                      </Table>
                    </Card.Text>
                  </div>
                </Card.Body>
                <Card.Body>
                  <div>
                    <Card.Text>
                      <strong>
                        {' '}
                        {dia - 1}/{mes}
                      </strong>
                      <Table
                        responsive
                        striped
                        bordered
                        hover
                        variant="light"
                        size="sm"
                      >
                        <thead>
                          <tr>
                            <td>Empresa</td>
                            <td>HOST</td>
                            <td>Backup</td>
                            <td>Files</td>
                            <td>Size</td>
                            <td>Disc Space</td>
                            <td>Status</td>
                            <td>Data</td>
                          </tr>
                        </thead>
                        {body.map((body) => {
                          const getDate01 = new Date(
                            body.started_at
                          ).toLocaleDateString()
                          let handleDia
                          let handleMes = ''
                          if (dia < 1) {
                            handleMes = '0'
                            dia = ''
                          } else if (dia <= 10) {
                            handleDia = `0`
                          } else if (dia >= 10) {
                            handleDia = ''
                          }
                          const montaData = `${handleDia}${
                            dia - 1
                          }/${handleMes}${mes}/${ano}`
                          if (getDate01 != montaData) return ' '
                          return <Corpobackup key={body.id} data={body} />
                        })}
                        <br />
                      </Table>
                    </Card.Text>
                  </div>
                </Card.Body>
                <Card.Body>
                  <div>
                    <Card.Text>
                      <strong>
                        {' '}
                        {dia - 2}/{mes}
                      </strong>
                      <Table
                        responsive
                        striped
                        bordered
                        hover
                        variant="light"
                        size="sm"
                      >
                        <thead>
                          <tr>
                            <td>Empresa</td>
                            <td>HOST</td>
                            <td>Backup</td>
                            <td>Files</td>
                            <td>Size</td>
                            <td>Disc Space</td>
                            <td>Status</td>
                            <td>Data</td>
                          </tr>
                        </thead>
                        {body.map((body) => {
                          const getDate01 = new Date(
                            body.started_at
                          ).toLocaleDateString()
                          let handleDia
                          let handleMes = ''
                          if (dia < 1) {
                            handleMes = '0'
                            dia = ''
                          } else if (dia <= 10) {
                            handleDia = `0`
                          } else if (dia >= 10) {
                            handleDia = ''
                          }
                          const montaData = `${handleDia}${
                            dia - 2
                          }/${handleMes}${mes}/${ano}`
                          if (getDate01 != montaData) return ' '
                          return <Corpobackup key={body.id} data={body} />
                        })}
                        <br />
                      </Table>
                    </Card.Text>
                  </div>
                </Card.Body>
                <Card.Body>
                  <div>
                    <Card.Text>
                      <strong>
                        {' '}
                        {dia - 3}/{mes}
                      </strong>
                      <Table
                        responsive
                        striped
                        bordered
                        hover
                        variant="light"
                        size="sm"
                      >
                        <thead>
                          <tr>
                            <td>Empresa</td>
                            <td>HOST</td>
                            <td>Backup</td>
                            <td>Files</td>
                            <td>Size</td>
                            <td>Disc Space</td>
                            <td>Status</td>
                            <td>Data</td>
                          </tr>
                        </thead>
                        {body.map((body) => {
                          const getDate01 = new Date(
                            body.started_at
                          ).toLocaleDateString()
                          let handleDia
                          let handleMes = ''
                          dia - 3
                          if (dia < 1) {
                            handleMes = '0'
                            dia = ''
                          } else if (dia <= 10) {
                            handleDia = `0`
                          } else if (dia >= 10) {
                            handleDia = ''
                          }
                          const montaData = `${handleDia}${dia}/${handleMes}${mes}/${ano}`
                          console.log(montaData + ' 2')
                          if (getDate01 != montaData) return ' '
                          return <Corpobackup key={body.id} data={body} />
                        })}
                        <br />
                      </Table>
                    </Card.Text>
                  </div>
                </Card.Body>
                <Card.Body>
                  <div>
                    <Card.Text>
                      <strong>
                        {' '}
                        {dia - 4}/{mes}
                      </strong>
                      <Table
                        responsive
                        striped
                        bordered
                        hover
                        variant="light"
                        size="sm"
                      >
                        <thead>
                          <tr>
                            <td>Empresa</td>
                            <td>HOST</td>
                            <td>Backup</td>
                            <td>Field</td>
                            <td>Status</td>
                            <td>Data</td>
                          </tr>
                        </thead>
                        {body.map((body) => {
                          const getDate01 = new Date(
                            body.started_at
                          ).toLocaleDateString()
                          let handleDia
                          let handleMes = ''
                          dia - 4
                          if (dia < 1) {
                            handleMes = '0'
                            dia = ''
                          } else if (dia <= 10) {
                            handleDia = `0`
                          } else if (dia >= 10) {
                            handleDia = ''
                          }
                          const montaData = `${handleDia}${dia}/${handleMes}${mes}/${ano}`
                          console.log(montaData)
                          if (getDate01 != montaData) return ' '
                          return <Corpobackup key={body.id} data={body} />
                        })}
                        <br />
                      </Table>
                    </Card.Text>
                  </div>
                </Card.Body>
              </Card>
              <br />
              <br />
            </Container>
          </TableContainer>
          <br />
        </div>
      </div>
    </div>
  )
}

export default ReportSemanal
